import BasicModel from "./basic_model";

export default class PhysicalActivityArea extends BasicModel {
  render = () => {
    this.setupContext();

    this.context.beginPath();
    this.context.moveTo(this.x(), this.y());

    for (const p in this.points) {
      const point = this.points[p];
      this.context.lineTo(point[2] * this.context.scale, point[3] * this.context.scale);
    }

    this.context.lineWidth = 1;
    this.context.strokeStyle = "rgba(200, 200, 0, 0.6)";
    this.context.fillStyle = "rgba(200, 200, 0, 0.6)";
    this.context.stroke();
    this.context.fill();

    this.resetContext();
  }


}



